import { useMemo, useState } from 'react';

import { DrawViewPreview } from 'approot/activity-builder/components/draw/draw-view.style';
import type { DrawAnswerFragment } from '../../present/activity-answers.graphql.generated';
import DrawCanvasPreview from 'approot/activity-builder/components/draw/draw-canvas-preview';
import { DrawData } from 'approot/activity-builder/components/draw/draw.constants';
import * as Styled from './draw-response-preview.style';
import { LanguageCodes } from 'global/constants';

type Props = {
  ariaLabel: string;
  id: string;
  imageUrl?: string | null;
  dimensionsData: {
    width: number;
    height: number;
  };
  answerUuid: string | null;
  answerUpdatedAt: Date | null;
  answer: DrawAnswerFragment | null;
  questionData?: DrawData | null;
  language: LanguageCodes;
};

const DrawResponsePreview = ({
  ariaLabel,
  id,
  dimensionsData,
  imageUrl,
  answer,
  answerUuid,
  answerUpdatedAt,
  questionData,
  language,
}: Props) => {
  const [previewRef, setPreviewRef] = useState<HTMLDivElement | null>(null);

  const paddingTop = useMemo(
    () => (dimensionsData.height / dimensionsData.width) * 100,
    [dimensionsData]
  );

  return (
    <Styled.DrawResponsePreview
      style={{
        paddingTop: `${paddingTop}%`,
      }}
    >
      <DrawViewPreview role="image" ref={setPreviewRef} aria-label={ariaLabel}>
        {answer && previewRef && (
          <DrawCanvasPreview
            imageUrl={imageUrl}
            dimensionsData={dimensionsData}
            id={`${answerUuid}-${id}`}
            // this key is to re-render on data updates could instead use an effect
            key={`${id}-${answerUuid}-${answerUpdatedAt}`}
            containerEl={previewRef}
            answer={answer.drawing}
            questionData={questionData}
            language={language}
          />
        )}
      </DrawViewPreview>
    </Styled.DrawResponsePreview>
  );
};

export default DrawResponsePreview;
